import { CountResponse } from '@interfaces/common.interface';
import {
  CreateTherapyDrugRequest,
  CreateTherapyRequestBody,
  DeleteTherapyDrugRequest,
  GetTherapiesRequestParams,
  Therapy,
  TherapyDrug,
  TherapyWithDrugs,
  UpdateTherapyDrugRequest,
  UpdateTherapyRequest,
} from '@interfaces/therapies.interface';

import api from './';

export const {
  useGetTherapyByIdQuery,
  useCountTherapiesQuery,
  useGetManyTherapiesQuery,
  useCreateTherapyMutation,
  useUpdateTherapyMutation,
  useDeleteTherapyMutation,
  useCreateTherapyDrugMutation,
  useUpdateTherapyDrugMutation,
  useDeleteTherapyDrugMutation,
} = api.injectEndpoints({
  endpoints: (build) => ({
    getTherapyById: build.query<TherapyWithDrugs, string>({
      query: (id) => ({ url: `therapies/${id}` }),
      providesTags: ['therapies'],
    }),
    countTherapies: build.query<CountResponse, void>({
      query: () => ({ url: 'therapies/count' }),
      providesTags: ['therapies'],
    }),
    getManyTherapies: build.query<Therapy[], GetTherapiesRequestParams>({
      query: (params) => ({ url: 'therapies', params }),
      providesTags: ['therapies'],
    }),
    createTherapy: build.mutation<Therapy, CreateTherapyRequestBody>({
      query: (body) => ({
        url: 'therapies',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['therapies'],
    }),
    updateTherapy: build.mutation<Therapy, UpdateTherapyRequest>({
      query: ({ id, body }) => ({
        url: `therapies/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['therapies'],
    }),
    deleteTherapy: build.mutation<Therapy, string>({
      query: (id) => ({
        url: `therapies/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['therapies'],
    }),
    createTherapyDrug: build.mutation<TherapyDrug, CreateTherapyDrugRequest>({
      query: ({ therapyId, body }) => ({
        url: `therapies/${therapyId}/drugs`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['therapies'],
    }),
    updateTherapyDrug: build.mutation<TherapyDrug, UpdateTherapyDrugRequest>({
      query: ({ therapyId, drugAic, body }) => ({
        url: `therapies/${therapyId}/drugs/${drugAic}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['therapies'],
    }),
    deleteTherapyDrug: build.mutation<TherapyDrug, DeleteTherapyDrugRequest>({
      query: ({ therapyId, drugAic }) => ({
        url: `therapies/${therapyId}/drugs/${drugAic}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['therapies'],
    }),
  }),
});
